import { BRAND_NAME } from "@chef/constants";

export const brand = {
  AMK: {},
  GL: {},
  LMK: { DISCLAIMER: "Basvarorna kan innehålla andra allergener" },
  RN: { DISCLAIMER: "Basisvarerne kan indeholde andre allergener" },
}[BRAND_NAME];
